import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.scss";

export default function WhatsAppButton() {
  return (
    <div className="whatsapp-button-container">
      <Link
        to="https://api.whatsapp.com/message/BP4RV5ECQACPE1?autoload=1&app_absent=0"
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={24} />
      </Link>
      <span className="notification-badge"></span>
    </div>
  );
}